import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { AddShuttleDialogComponent } from 'src/app/core/dialogs/add-shuttle-dialog/add-shuttle-dialog.component';
import { AddTierDialogComponent } from 'src/app/core/dialogs/add-tier-dialog/add-tier-dialog.component';
import { CopyTierDialogComponent } from 'src/app/core/dialogs/copy-tier-dialog/copy-tier-dialog.component';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { BtnCellRendererTick } from 'src/app/core/grid/btn-cell-render-tick';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { ManagementTierSetupService } from 'src/app/service/management/tier-setup.service';

export interface DialogData {
  header: string;
  fromPeriodLabel: string;
  periodList: any;
}

export interface ShuttleDialogData {
  eventType: string;
  shuttleId: number;
  header: string;
  routeGroup: string;
  minimumConnection: number;
  fifo: string;
  unloadBased: string;
  tierId: number;
}

@Component({
  selector: 'app-tiersetup',
  templateUrl: './tiersetup.component.html',
  styleUrls: ['./tiersetup.component.scss'],
  standalone: false
})
export class TierSetupComponent implements OnInit {
  TIERS_gridApi: any;
  TIERS_icons;
  TIERS_columnDefs;
  TIERS_displayRowData = [];
  TIERS_context: any;
  TIERS_rowCount;
  TIERS_currentPageNo: any;
  TIERS_currentPageBoolean: boolean = false;
  TIERS_totalPage: any;
  TIERS_currentPageForTotalPage: any;
  TIERS_isLastPageFound: any;
  TIERS_selected_period_id;
  TIERS_selected_period_value: string;


  TIERS_TLMS_Route_Type_Code_Data = []
  TIERS_Master_Table_Data = []
  TIERS_Dependency_Data = []
  TIERS_Lock_Trigger_Data = []
  TIERS_TLMS_Include_Other_Tier_Data = []

  SHUTTLES_gridApi: any;
  SHUTTLES_icons;
  SHUTTLES_columnDefs;
  SHUTTLES_displayRowData = [];
  SHUTTLES_context: any;
  SHUTTLES_rowCount;
  SHUTTLES_currentPageNo: any;
  SHUTTLES_currentPageBoolean: boolean = false;
  SHUTTLES_totalPage: any;
  SHUTTLES_currentPageForTotalPage: any;
  SHUTTLES_isLastPageFound: any;
  SHUTTLES_selected_period_id;
  SHUTTLES_selected_period_value: string

  SHUTTLES_SuccessMessage = ""
  SHUTTLES_ErrorMessage = ""

  periodData = []
  defaultColDef;
  successMessage
  errorMessage
  isAccessible = true;
  edit_shtl = 'edit-shuttle'
  constructor(private readonly router: Router, public dialog: MatDialog, private readonly tiersetupService: ManagementTierSetupService,
    private readonly constants: Constants, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly groupIStateService : GroupIStateService) {
    this.TIERS_context = {
      componentParent: this
    };

    this.SHUTTLES_context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, floatingFilter: true,
      filterParams: {
        newRowsAction: 'keep'
      },
      suppressHeaderFilterButton: true, suppressCellSelection: true
    }
  }


  ngOnInit(): void {

    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.TIERS_columnDefs = [
      // {
      //   headerName: "Sr. No.", field: "id",
      //   autoHeight: true
      // },
      {
        headerName: "Tier Name", field: "tierName", sortable: true, unSortIcon: true, cellClass: "left_align", floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', width: 120
      },
      {
        headerName: "Tier Position", field: "tierposition", sortable: true, unSortIcon: true, cellClass: "left_align",
        width: 60
      },
      {
        headerName: "TLMS Route Type Code", field: "tlmsRouteTypeCode", sortable: true, unSortIcon: true, cellClass: "left_align", width: 100
      },
      {
        headerName: "Master Table", field: "masterTable", sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', autoHeight: true, width: 70
      },
      {
        headerName: "Dependency", field: "dependency", sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', autoHeight: true, width: 110
      },
      {
        headerName: "Lock Trigger", field: "lockTrigger", sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', autoHeight: true, width: 110
      },
      {
        headerName: "Include other Tier Data", field: "otherTierData", sortable: true, unSortIcon: true, cellClass: "left_align", width: 100
      },
      {
        headerName: "Edit / Delete", field: "tiers_editdelete", width: 50,
        cellRenderer: BtnCellRendererEditDelete

      }];
    this.TIERS_icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };

    this.SHUTTLES_columnDefs = [
      // {
      //   headerName: "Sr. No.",  field: "id",
      //   autoHeight: true
      // },
      {
        headerName: "Route Group", field: "routeGroup", floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, autoHeight: true,
      },
      {
        headerName: "Minimum Connection", field: "minimumConnection", width: 120,
        sortable: true, unSortIcon: true, autoHeight: true
      },
      {
        headerName: "Is FIFO", field: "fifo", sortable: true, unSortIcon: true, width: 90,
        cellRenderer: BtnCellRendererTick
      },
      {
        headerName: "Is Unload Based", field: "unloadBased", sortable: true, unSortIcon: true, width: 90,
        cellRenderer: BtnCellRendererTick

      },
      {
        headerName: "Tier", field: "tierId", autoHeight: true, width: 90,
      },
      {
        headerName: "Edit / Delete", field: "shuttles_editdelete", width: 70,
        cellRenderer: BtnCellRendererEditDelete
      }];
    this.SHUTTLES_icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.getTiersBaseDropDownData();
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }
  async getTiersBaseDropDownData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    await this.tiersetupService.getTLMSRouteTypeCodes().then(x => {

      if (x && x.length > 0) {
        this.TIERS_TLMS_Route_Type_Code_Data = [];
        x.forEach((obj, _index) => {
          this.TIERS_TLMS_Route_Type_Code_Data.push({
            id: Number(obj), value: obj
          })
        });

      }
    })

    await this.tiersetupService.getMasterTableDataDropDown().then(x => {

      if (x && x.length > 0) {
        this.TIERS_Master_Table_Data = [];
        x.forEach((obj, _index) => {
          this.TIERS_Master_Table_Data.push({
            id: Number(obj.masterTblId), value: obj.masterTblName
          })
        });
      }
    })

    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.tiersRefreshData()
  }

  componentEventHandler(event) {

    if (event.module == "Tiers") { // NOSONAR
      if (event.eventType == "NOTIFICATION_ERROR") { // NOSONAR
        this.errorMessage = event.eventMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      } else if (event.eventType == "CHANGE_PERIOD") { // NOSONAR
        this.TIERS_selected_period_id = event.periodId
        this.TIERS_selected_period_value = event.periodValue
        this.tiersRefreshData();
      }
    } else if (event.module == "Shuttles") { // NOSONAR
      if (event.eventType == "NOTIFICATION_ERROR") { // NOSONAR
        this.SHUTTLES_ErrorMessage = event.eventMessage;
        setTimeout(() => {
          this.SHUTTLES_SuccessMessage = "";
          this.SHUTTLES_ErrorMessage = "";
        }, this.constants.notificationMessageTime);

      } else if (event.eventType == "CHANGE_PERIOD") { // NOSONAR
        this.SHUTTLES_selected_period_id = event.periodId
        this.SHUTTLES_selected_period_value = event.periodValue
        this.shuttlesRefreshData();
      }
    }
  }


  async getDependencyLockTriggerAndOtherTiersData() {
    await this.tiersetupService.getDependencyAndLockTrigger(this.TIERS_selected_period_id).then(x => {
      if (x && x.length > 0) {
        this.TIERS_Dependency_Data = [];
        this.TIERS_Lock_Trigger_Data = [];
        x.forEach((obj, _index) => {
          this.TIERS_Dependency_Data.push({
            id: Number(obj.tierId), position: Number(obj.tierPosition), value: obj.description
          })
          this.TIERS_Lock_Trigger_Data.push({
            id: Number(obj.tierId), position: Number(obj.tierPosition), value: obj.description
          })
        });

      }
    })
    await this.tiersetupService.getOtherTierData(this.TIERS_selected_period_id).then(x => {

      if (x && x.length > 0) {
        this.TIERS_TLMS_Include_Other_Tier_Data = [];
        x.forEach((obj, _index) => {
          this.TIERS_TLMS_Include_Other_Tier_Data.push({
            id: Number(obj), value: obj
          })
        });

      }
    })
  }

  tiersRefreshData() {
    if (this.TIERS_selected_period_id) {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.getDependencyLockTriggerAndOtherTiersData();
      this.tiersetupService.loadDataTierSetUp(this.TIERS_selected_period_id).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          const model = this.TIERS_gridApi?.getFilterModel();
          this.TIERS_displayRowData = response;
          this.TIERS_gridApi?.setGridOption('rowData', this.TIERS_displayRowData);
          this.TIERS_rowCount = this.TIERS_displayRowData.length;
          this.TIERS_gridApi?.setFilterModel(model);
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      );

    }
  }

  shuttlesRefreshData() {
    if (this.SHUTTLES_selected_period_id) {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.tiersetupService.loadDataShuttle(this.SHUTTLES_selected_period_id).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          const model = this.SHUTTLES_gridApi?.getFilterModel();
          this.SHUTTLES_displayRowData = response;
          this.SHUTTLES_gridApi?.setGridOption('rowData', this.SHUTTLES_displayRowData);
          this.SHUTTLES_rowCount = this.SHUTTLES_displayRowData.length;
          this.SHUTTLES_gridApi?.setFilterModel(model);
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.SHUTTLES_ErrorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.SHUTTLES_SuccessMessage = "";
            this.SHUTTLES_ErrorMessage = "";
          }, this.constants.notificationMessageTime);

        }
      );
    }
  }
  tiersSizeToFit() { this.TIERS_gridApi?.sizeColumnsToFit(); }
  tiersOnGridReady(params) {
    this.TIERS_gridApi = params.api
    this.TIERS_gridApi.sizeColumnsToFit();
  }
  tiersOnPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.TIERS_gridApi?.setGridOption('paginationPageSize', Number(this.TIERS_displayRowData.length));}
    else
      {this.TIERS_gridApi?.setGridOption('paginationPageSize', Number(event.target.value));}
  }
  tiersGoToNexpage() { this.TIERS_gridApi.paginationGoToNextPage(); }

  tiersGoToPreviousPage() { this.TIERS_gridApi.paginationGoToPreviousPage()}

  tiersGoToFirstPage() { this.TIERS_gridApi.paginationGoToFirstPage(); }

  tiersGoToLastPage() { this.TIERS_gridApi.paginationGoToLastPage() }

  tiersGetCurrentPage(): boolean {
    this.TIERS_currentPageNo = this.TIERS_gridApi?.paginationGetCurrentPage();
    if (this.TIERS_currentPageNo == 0) { // NOSONAR
      this.TIERS_currentPageBoolean = true;
    }
    else { this.TIERS_currentPageBoolean = false; }
    return this.TIERS_currentPageBoolean;
  }
  tiersIsLastPage(): boolean {
    this.TIERS_totalPage = Number(this.TIERS_gridApi?.paginationGetTotalPages());
    this.TIERS_currentPageForTotalPage = Number(this.TIERS_gridApi?.paginationGetCurrentPage()) + 1;
    if (this.TIERS_totalPage == this.TIERS_currentPageForTotalPage) { // NOSONAR
      this.TIERS_isLastPageFound = true;
    }
    else {
      this.TIERS_isLastPageFound = false;
    }
    return this.TIERS_isLastPageFound;
  }

  shuttlesSizeToFit() { this.SHUTTLES_gridApi?.sizeColumnsToFit(); }
  shuttlesOnGridReady(params) {
    this.SHUTTLES_gridApi = params.api
    this.SHUTTLES_gridApi.sizeColumnsToFit();
  }
  shuttlesOnPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.SHUTTLES_gridApi?.setGridOption('paginationPageSize', Number(this.SHUTTLES_displayRowData.length));}
    else
      {this.SHUTTLES_gridApi?.setGridOption('paginationPageSize', Number(event.target.value));}
  }
  shuttlesGoToNexpage() { this.SHUTTLES_gridApi.paginationGoToNextPage(); }

  shuttlesGoToPreviousPage() { this.SHUTTLES_gridApi.paginationGoToPreviousPage()}

  shuttlesGoToFirstPage() { this.SHUTTLES_gridApi.paginationGoToFirstPage(); }

  shuttlesGoToLastPage() { this.SHUTTLES_gridApi.paginationGoToLastPage() }

  shuttlesGetCurrentPage(): boolean {
    this.SHUTTLES_currentPageNo = this.SHUTTLES_gridApi?.paginationGetCurrentPage();
    if (this.SHUTTLES_currentPageNo == 0) { // NOSONAR
      this.SHUTTLES_currentPageBoolean = true;
    }
    else { this.SHUTTLES_currentPageBoolean = false; }
    return this.SHUTTLES_currentPageBoolean;
  }
  shuttlesIsLastPage(): boolean {
    this.SHUTTLES_totalPage = Number(this.SHUTTLES_gridApi?.paginationGetTotalPages());
    this.SHUTTLES_currentPageForTotalPage = Number(this.SHUTTLES_gridApi?.paginationGetCurrentPage()) + 1;
    if (this.SHUTTLES_totalPage == this.SHUTTLES_currentPageForTotalPage) { // NOSONAR
      this.SHUTTLES_isLastPageFound = true;
    }
    else {
      this.SHUTTLES_isLastPageFound = false;
    }
    return this.SHUTTLES_isLastPageFound;
  }
  deleteTemplateRow(data, pagename) {

    let displayRowIndex;
    if (pagename == 'tiers_editdelete') { // NOSONAR

      const dialogRef = this.dialog.open(
        DeleteDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '170px',
        data: {
          header: 'Are you sure you want to delete this Tier?',
          description: data.tierName,
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'ConfirmEvent') { // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.tiersetupService.deleteTier(data.tierId).subscribe(
            response => {

              if (response == "Success") { // NOSONAR
                this.successMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTime);
                displayRowIndex = this.TIERS_displayRowData.findIndex(x => x.tierId == data.tierId)  // NOSONAR
                this.TIERS_displayRowData.splice(displayRowIndex, 1);
                this.TIERS_gridApi?.setGridOption('rowData', this.TIERS_displayRowData);
                this.TIERS_rowCount = this.TIERS_displayRowData.length;
              }
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

            }, _error => {

              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            }
          );
        }
      });
    } else if (pagename == 'shuttles_editdelete') {  // NOSONAR
      const dialogRef = this.dialog.open(
        DeleteDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '170px',
        data: {
          header: 'Are you sure you want to delete this Shuttle?',
          description: data.routeGroup,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result.event == 'ConfirmEvent') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.tiersetupService.deleteShuttle(data.shuttleId).subscribe(
            response => {
              if (response == "Success") {  // NOSONAR
                this.SHUTTLES_SuccessMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.SHUTTLES_SuccessMessage = "";
                  this.SHUTTLES_ErrorMessage = "";
                }, this.constants.notificationMessageTime);
                displayRowIndex = this.SHUTTLES_displayRowData.findIndex(x => x.shuttleId == data.shuttleId)  // NOSONAR
                this.SHUTTLES_displayRowData.splice(displayRowIndex, 1);
                this.SHUTTLES_gridApi?.setGridOption('rowData', this.SHUTTLES_displayRowData);
                this.SHUTTLES_rowCount = this.SHUTTLES_displayRowData.length;
              }
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

            }, _error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.SHUTTLES_ErrorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.SHUTTLES_SuccessMessage = "";
                this.SHUTTLES_ErrorMessage = "";
              }, this.constants.notificationMessageTime);
            }
          );

        }
      });

    }
  }
  editTemplateRow(data, pagename) {
    if (pagename == 'tiers_editdelete') {  // NOSONAR
      this.editDialog('edit-tier', data)
    } else if (pagename == 'shuttles_editdelete') {  // NOSONAR
      this.editDialog(this.edit_shtl, data)
    }
  }
  

  addDialog(event): void {

    if (event == 'add-tier') {  // NOSONAR
      const dialogRef = this.dialog.open(
        AddTierDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '415px',
        data: {
          header: 'Add Tier',
          eventType: 'ADD',
          periodId: this.TIERS_selected_period_id,
          tlmsRouteTypeCodeData: this.TIERS_TLMS_Route_Type_Code_Data,
          masterTableData: this.TIERS_Master_Table_Data,
          dependencyData: this.TIERS_Dependency_Data,
          lockTriggerData: this.TIERS_Lock_Trigger_Data,
          includeOtherTierData: this.TIERS_TLMS_Include_Other_Tier_Data
        }
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'SaveEvent') {  // NOSONAR

          this.successMessage = this.constants.APIDataSaved;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
          this.tiersRefreshData();

        }
      });
    } else if (event == 'add-shuttle') {  // NOSONAR
      const dialogRef = this.dialog.open(
        AddShuttleDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '340px',
        data: {
          header: 'Add Shuttle',
          eventType: 'ADD'
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'SaveEvent') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.tiersetupService.addShuttle(result.tierId, result.minimumConnection, this.SHUTTLES_selected_period_id, result.routeGroup, result.fifo, result.unloadBased).subscribe(
            response => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              if (response == "Success") {  // NOSONAR
                this.SHUTTLES_SuccessMessage = this.constants.APIDataSaved;
                setTimeout(() => {
                  this.SHUTTLES_SuccessMessage = "";
                  this.SHUTTLES_ErrorMessage = "";
                }, this.constants.notificationMessageTime);
                this.shuttlesRefreshData();
              }

            },_error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.SHUTTLES_ErrorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.SHUTTLES_SuccessMessage = "";
                this.SHUTTLES_ErrorMessage = "";
              }, this.constants.notificationMessageTime);
            });
        }
      });
    }
  }

  editDialog(event, data): void {
    const comp: any = event == 'edit-tier' ? AddTierDialogComponent : AddShuttleDialogComponent  // NOSONAR
    let dialogRef;
    if (event == 'edit-tier') {  // NOSONAR
      dialogRef = this.dialog.open(
        comp, {
        disableClose: true,
        width: '500px',
        height: '415px',
        data: {
          header: 'Edit Tier',
          eventType: 'EDIT',
          periodId: this.TIERS_selected_period_id,
          tlmsRouteTypeCodeData: this.TIERS_TLMS_Route_Type_Code_Data,
          masterTableData: this.TIERS_Master_Table_Data,
          dependencyData: this.TIERS_Dependency_Data,
          lockTriggerData: this.TIERS_Lock_Trigger_Data,
          includeOtherTierData: this.TIERS_TLMS_Include_Other_Tier_Data,
          tierId: data.tierId,
          tierposition: data.tierposition,
          tierName: data.tierName,
          tlmsRouteTypeCode: data.tlmsRouteTypeCode,
          masterTable: data.masterTable,
          dependency: data.dependency,
          lockTrigger: data.lockTrigger,
          otherTierData: data.otherTierData
        }
      });
    } else if (event == this.edit_shtl) {  // NOSONAR
      dialogRef = this.dialog.open(
        comp, {
        disableClose: true,
        width: '500px',
        height: '340px',
        data: {
          header: 'Edit Shuttle',
          eventType: 'EDIT',
          shuttleId: data.shuttleId,
          routeGroup: data.routeGroup,
          minimumConnection: data.minimumConnection,
          fifo: data.fifo,
          unloadBased: data.unloadBased,
          tierId: data.tierId
        }
      });
    }


    dialogRef.afterClosed().subscribe(result => {
      const displayRowIndex = -1;
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (event == 'edit-tier') {  // NOSONAR

          this.successMessage = this.constants.APIDataSaved;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
          this.tiersRefreshData();

        } else if (event == this.edit_shtl) {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.tiersetupService.updateShuttle(result.shuttleId, result.tierId, result.minimumConnection, result.fifo, result.unloadBased).subscribe(
            response => {
              if (response == "Success") {  // NOSONAR
                this.SHUTTLES_SuccessMessage = this.constants.APIDataSaved;
                setTimeout(() => {
                  this.SHUTTLES_SuccessMessage = "";
                  this.SHUTTLES_ErrorMessage = "";
                }, this.constants.notificationMessageTime);
                this.shuttlesRefreshData();
              }
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

            }, error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.SHUTTLES_ErrorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.SHUTTLES_SuccessMessage = "";
                this.SHUTTLES_ErrorMessage = "";
              }, this.constants.notificationMessageTime);
            });
        }
      }
    });
  }

  copyDialog(event): void {
    const dialogRef = this.dialog.open(CopyTierDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: event == 'copy-tier' ? 'Copy Tier' : 'Copy Shuttle',  // NOSONAR
        fromPeriodLabel: event == 'copy-tier' ? this.TIERS_selected_period_value : this.SHUTTLES_selected_period_value,  // NOSONAR
        periodList: this.periodData
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') {  // NOSONAR
        if (event == 'copy-tier') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.tiersetupService.copyTier(Number(this.TIERS_selected_period_id), Number(result.selected_period_id)).subscribe(
            response => {
              if (response == "Success") {  // NOSONAR
                this.successMessage = this.constants.APIDataSaved;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTime);
              }
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            }, _error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            });

        }
        if (event == 'copy-shuttle') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.tiersetupService.copyShuttle(Number(this.SHUTTLES_selected_period_id), Number(result.selected_period_id)).subscribe(
            response => {
              if (response == "Success") {  // NOSONAR
                this.SHUTTLES_SuccessMessage = this.constants.APIDataSaved;
                setTimeout(() => {
                  this.SHUTTLES_SuccessMessage = "";
                  this.SHUTTLES_ErrorMessage = "";
                }, this.constants.notificationMessageTime);
              }
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            }, _error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.SHUTTLES_ErrorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.SHUTTLES_SuccessMessage = "";
                this.SHUTTLES_ErrorMessage = "";
              }, this.constants.notificationMessageTime);
            });

        }
      }
    });
  }
  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: { header: 'Add To Queue' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }

  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
}
